import { numberParser } from '../inboundParsers';
export const UPDATE_JACKS_AND_AMMO_PAYLOAD_DEFINITION = {
    definitionParts: [
        { name: 'numJacks', parser: numberParser },
        { name: 'numAmmo', parser: numberParser }
    ]
};
